import { switchOrganisationAction } from "src/page/auth/loginSlice";
import { useAppDispatch, useAppSelector } from "src/page/store";
import { refreshSession } from "src/utils";
import Button from "@mui/material/Button";
import ChangeOrgModal from "../changeOrgModal/ChangeOrgModal";
import Modalui from "../UI/modal/Modalui";
import { useState } from "react";

interface Iprops {
  orgId: string;
  cb?: () => void;
  buttonText?: string;
  buttonStyle?: React.CSSProperties;
}

const defaultButtonStyle: React.CSSProperties = {
  background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
  color: "#fff",
  display: "flex",
  flexWrap: "nowrap",
  height: "36px",
  fontWeight: "600",
  padding: "0 16px",
  textTransform: "none",
  borderRadius: "8px",
  fontSize: "13px",
  boxShadow: "0 2px 6px rgba(30, 41, 59, 0.18)",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  whiteSpace: "nowrap"
};

function AdminSwitchOrg({ orgId, cb, buttonText = "Switch", buttonStyle }: Iprops) {
  const [openChangeOrgConfirm, setOpenChangeOrgConfirm] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { userInfo, cognitoRefreshToken } = useAppSelector((state) => state.auth);

  const handleSwitchOrganisation = () => {
    if (!userInfo) return;
    dispatch(
      switchOrganisationAction(
        {
          organisationId: orgId,
          userId: userInfo.id
        },
        () => {
          refreshSession(cognitoRefreshToken ?? undefined);
          setOpenChangeOrgConfirm(false);
          if (cb) cb();
        }
      )
    );
  };

  const handleCloseConfirmationModal = () => {
    setOpenChangeOrgConfirm(false);
  };

  return (
    <>
      <Modalui open={openChangeOrgConfirm} handleClose={handleCloseConfirmationModal} modalType="switch_org">
        <ChangeOrgModal handleClose={handleCloseConfirmationModal} onConfirm={handleSwitchOrganisation} />
      </Modalui>
      <Button
        variant="contained"
        sx={{ ...defaultButtonStyle, ...buttonStyle }}
        onClick={() => setOpenChangeOrgConfirm(true)}
      >
        {buttonText}
      </Button>
    </>
  );
}

export default AdminSwitchOrg;
